export const POLICY_USERS = {
    CREATE: "create_users",
    READ: "show_users",
    SELF_READ: "show_own_user",
    UPDATE: "edit_users",
    SELF_UPDATE: "edit_own_user",
    DELETE: "delete_users",
    DISABLE: "disable_users",
    SHOW_DISABLED: "show_disabled_users",
    SHOW_COMPANY: "show_users_companies"
};

export const POLICY_CUSTOMERS = {
    CREATE: "create_customers",
    READ: "show_customers",
    UPDATE: "edit_customers",
    DELETE: "delete_customers",
    SHOW_DISABLED: "show_disabled_customers",
    SHOW_COMPANY: "show_customers_companies",
    EXPORT: "export_customers"
};

export const POLICY_CUSTOMERS_MAPPINGS = {
    CREATE: "create_customers_mappings",
    READ: "show_customers_mappings",
    UPDATE: "edit_customers_mappings",
    SAFE_UPDATE: "edit_customers_mappings_only_master",
    UPDATE_BOOKED_INSTALLATION: "edit_customers_mappings_booked_installation",
    DELETE: "delete_customers_mappings",
    DISABLE: "disable_customers_mappings",
    NO_MASTER_SLAVE_CHECK: "no_check_master_slave"
};

export const POLICY_INSTALLATIONS = {
    CREATE_NEW_INSTALLATION: "create_new_installation",
    CREATE_MIGRATION: "create_migration",
    READ: "show_installations",
    UPDATE: "edit_installations",
    DELETE: "delete_installations",
    FORCE_DELETE: "force_installations_delete",
    TCC_DELETE: "tcc_delete",
    DISABLE: "disable_installations",
    READ_PWD_ADMIN: "read_pwd_admin_l1",
    READ_PWD_ADMIN_L2: "read_pwd_admin_l2",
    SHOW_COMPANY: "show_installation_company",
    EXPORT: "export_installations",
    RETRY: "retry_provisioning",
    SEND_MAIL: "send_mail",
    LOCK: "lock_installations",
    FORCE_PROVISIONING_SUCCEEDED: "force_provisioning_succeeded",
    FORCE_PROVISIONING_FAILED: "force_provisioning_failed",
    TEMPLATE: "show_installation_template",
    TRANSFER: "transfer_installation",
    GET_INFO: "get_installation_info",
    DATABASE_SUPPORT: "database_support",
    GET_LIMITED_INFO: "get_limited_installation_info",
    COMPANY_MODIFY: "company_modify",
    STOP_OPERATION: "stop_operation",
    TSX_NOTIFICATION: "tsx_notification",
    DOWNLOAD_BACKUP: "download_backup"
};

export const POLICY_COMPANIES = {
    CREATE: "create_companies",
    SAFE_CREATE: "safe_create_companies",
    READ: "show_companies",
    UPDATE: "edit_companies",
    UPDATE_SLAVE_ONLY: "edit_only_slave_companies",
    DELETE: "delete_companies",
    DELETE_SLAVE_ONLY: "delete_only_slave_companies",
    DISABLE: "disable_companies",
    DISABLE_SLAVE_ONLY: "disable_only_slave_companies",
    FILTER_OWN_COMPANY_ONLY: "filter_own_company_only",
    FILTER_NO_COMPANY: "filter_no_company",
    FILTER_LIMIT_COMPANIES: "filter_limit_companies",
    SHOW_LICENSES: "show_companies_licenses",
    UPDATE_LICENSES: "update_companies_licenses"
};

export const POLICY_TICKETS = {
    CREATE: "create_tickets",
    SAFE_CREATE: "safe_create_tickets",
    READ: "show_tickets",
    READ_ALL_USERS: "show_all_tickets",
    READ_ALL_COMPANIES: "show_all_companies_tickets",
    UPDATE: "edit_tickets",
    DELETE: "delete_tickets",
    SELF_ASSIGN: "self_assign_ticket",
    REMOVE_ASSIGNEE: "romove_assignee_ticket",
    SHOW_OWNERSHIP: "show_ticket_ownership"
};

export const POLICY_UTILITIES = {
    DOWNLOAD: "can_download_utilities",
    UPLOAD: "can_upload_utilities",
    GUIDE: "can_view_guide"
};

export const POLICY_ROLE_MAPPINGS = {
    READ: "show_role_mappings",
    SELF_READ: "show_own_role_mappings",
    UPDATE: "edit_role_mappings"
};

export const POLICY_NOTIFICATIONS = {
    SEND_NOTIFICATIONS: "send_notifications"
};

export const POLICY_OPERATIONS = {
    CREATE: "create_operations",
    READ: "show_operations",
    UPDATE: "edit_operations",
    DELETE: "delete_operations"
};

export const POLICY_CONSOLE = {
    CAN_LOGIN_ON_MAINTENANCE: "can_login_on_maintenance",
    // Funzioni "ad alto privilegio" riservate al ruolo admin_console_plus
    // (visualizzatore log, configurazione log, tabella operations, cambio ruolo).
    HIGH_PRIVILEGE_FUNCTIONS: "high_privilege_functions"
};

export const POLICY_ROLES = {
    READ: "show_roles",
    SUPER_READ: "show_all_roles",
    RESTRICTED_READ: "show_restricted_roles",
    IMPERSONATE: "impersonate_roles",
    IMPERSONATE_OFF: "impersonate_off"
};

export const POLICY_PASSWORD = {
    CHANGE: "change_password",
    RESET: "reset_passwords",
    SELF_RESET: "reset_own_password"
};

const POLICIES_CODES = {
    [POLICY_USERS.CREATE]: 0,
    [POLICY_USERS.READ]: 1,
    [POLICY_USERS.SELF_READ]: 2,
    [POLICY_USERS.UPDATE]: 3,
    [POLICY_USERS.SELF_UPDATE]: 4,
    [POLICY_USERS.DELETE]: 5,
    [POLICY_USERS.DISABLE]: 6,
    [POLICY_USERS.SHOW_DISABLED]: 7,
    [POLICY_USERS.SHOW_COMPANY]: 9,

    [POLICY_CUSTOMERS.CREATE]: 10,
    [POLICY_CUSTOMERS.READ]: 11,
    [POLICY_CUSTOMERS.UPDATE]: 12,
    [POLICY_CUSTOMERS.DELETE]: 13,
    [POLICY_CUSTOMERS.SHOW_DISABLED]: 14,
    [POLICY_CUSTOMERS.SHOW_COMPANY]: 15,
    [POLICY_CUSTOMERS.EXPORT]: 16,

    [POLICY_CUSTOMERS_MAPPINGS.CREATE]: 17,
    [POLICY_CUSTOMERS_MAPPINGS.READ]: 18,
    [POLICY_CUSTOMERS_MAPPINGS.UPDATE]: 19,
    [POLICY_CUSTOMERS_MAPPINGS.SAFE_UPDATE]: 20,
    [POLICY_CUSTOMERS_MAPPINGS.UPDATE_BOOKED_INSTALLATION]: 21,
    [POLICY_CUSTOMERS_MAPPINGS.DELETE]: 22,
    [POLICY_CUSTOMERS_MAPPINGS.DISABLE]: 23,
    [POLICY_CUSTOMERS_MAPPINGS.NO_MASTER_SLAVE_CHECK]: 24,

    [POLICY_INSTALLATIONS.CREATE_NEW_INSTALLATION]: 25,
    [POLICY_INSTALLATIONS.CREATE_MIGRATION]: 26,
    [POLICY_INSTALLATIONS.READ]: 27,
    [POLICY_INSTALLATIONS.UPDATE]: 28,
    [POLICY_INSTALLATIONS.DELETE]: 29,
    [POLICY_INSTALLATIONS.FORCE_DELETE]: 30,
    [POLICY_INSTALLATIONS.DISABLE]: 31,
    [POLICY_INSTALLATIONS.READ_PWD_ADMIN]: 32,
    [POLICY_INSTALLATIONS.READ_PWD_ADMIN_L2]: 33,
    [POLICY_INSTALLATIONS.SHOW_COMPANY]: 35,
    [POLICY_INSTALLATIONS.EXPORT]: 36,
    [POLICY_INSTALLATIONS.RETRY]: 37,
    [POLICY_INSTALLATIONS.SEND_MAIL]: 38,
    [POLICY_INSTALLATIONS.LOCK]: 39,

    [POLICY_COMPANIES.CREATE]: 40,
    [POLICY_COMPANIES.SAFE_CREATE]: 41,
    [POLICY_COMPANIES.READ]: 42,
    [POLICY_COMPANIES.UPDATE]: 43,
    [POLICY_COMPANIES.UPDATE_SLAVE_ONLY]: 44,
    [POLICY_COMPANIES.DELETE]: 45,
    [POLICY_COMPANIES.DELETE_SLAVE_ONLY]: 46,
    [POLICY_COMPANIES.DISABLE]: 47,
    [POLICY_COMPANIES.DISABLE_SLAVE_ONLY]: 48,
    [POLICY_COMPANIES.FILTER_OWN_COMPANY_ONLY]: 49,
    [POLICY_COMPANIES.FILTER_NO_COMPANY]: 50,
    [POLICY_COMPANIES.FILTER_LIMIT_COMPANIES]: 51,
    [POLICY_COMPANIES.SHOW_LICENSES]: 52,
    [POLICY_COMPANIES.UPDATE_LICENSES]: 53,

    [POLICY_TICKETS.CREATE]: 54,
    [POLICY_TICKETS.SAFE_CREATE]: 55,
    [POLICY_TICKETS.READ]: 56,
    [POLICY_TICKETS.READ_ALL_USERS]: 57,
    [POLICY_TICKETS.READ_ALL_COMPANIES]: 58,
    [POLICY_TICKETS.UPDATE]: 59,
    [POLICY_TICKETS.DELETE]: 60,
    [POLICY_TICKETS.SELF_ASSIGN]: 61,
    [POLICY_TICKETS.REMOVE_ASSIGNEE]: 62,
    [POLICY_TICKETS.SHOW_OWNERSHIP]: 63,

    [POLICY_UTILITIES.DOWNLOAD]: 64,
    [POLICY_UTILITIES.UPLOAD]: 65,
    [POLICY_UTILITIES.GUIDE]: 66,

    [POLICY_ROLE_MAPPINGS.READ]: 67,
    [POLICY_ROLE_MAPPINGS.SELF_READ]: 68,
    [POLICY_ROLE_MAPPINGS.UPDATE]: 69,

    [POLICY_NOTIFICATIONS.SEND_NOTIFICATIONS]: 70,

    [POLICY_CONSOLE.CAN_LOGIN_ON_MAINTENANCE]: 71,
    [POLICY_CONSOLE.HIGH_PRIVILEGE_FUNCTIONS]: 92,

    [POLICY_ROLES.READ]: 72,
    [POLICY_ROLES.RESTRICTED_READ]: 73,
    [POLICY_ROLES.SUPER_READ]: 74,
    [POLICY_ROLES.IMPERSONATE]: 75,
    [POLICY_ROLES.IMPERSONATE_OFF]: 76,

    [POLICY_INSTALLATIONS.TEMPLATE]: 77,

    [POLICY_PASSWORD.CHANGE]: 78,
    [POLICY_PASSWORD.RESET]: 79,
    [POLICY_PASSWORD.SELF_RESET]: 80,

    [POLICY_INSTALLATIONS.TRANSFER]: 81,
    [POLICY_INSTALLATIONS.GET_INFO]: 82,
    [POLICY_INSTALLATIONS.DATABASE_SUPPORT]: 83,
    [POLICY_INSTALLATIONS.GET_LIMITED_INFO]: 84,
    [POLICY_INSTALLATIONS.COMPANY_MODIFY]: 85,
    [POLICY_INSTALLATIONS.STOP_OPERATION]: 86,
    [POLICY_INSTALLATIONS.TSX_NOTIFICATION]: 87,

    [POLICY_OPERATIONS.CREATE]: 88,
    [POLICY_OPERATIONS.READ]: 89,
    [POLICY_OPERATIONS.UPDATE]: 90,
    [POLICY_OPERATIONS.DELETE]: 91,

    [POLICY_INSTALLATIONS.DOWNLOAD_BACKUP]: 93
};

export function compressPolicies(policies) {
    if (policies) {
        return policies.map(policy => {
            if (policy) {
                return POLICIES_CODES[policy];
            } else return -1;
        });
    }
    return [];
}

export function decompressPolicies(policies) {
    if (policies) {
        return policies.map(policy => {
            return Object.keys(POLICIES_CODES).find(
                key => policy === POLICIES_CODES[key]
            );
        });
    }
    return [];
}



// WEBPACK FOOTER //
// ./src/common/rolesManagement.js